/**
 * Mediatabs component. It displays photospanel, stickerspanel, backgroundspanel, layoutspanel and texts panels.
 * @constructor editor.mediatabs.MediaTabs
 * @param {object} dom DOM
 */

fx.ns("desktop.poster", class MediaTabs extends fx.Component{
    
	constructor(data)
	{
		super(data);
		this.assets = fx.get("assets");

		this.listenUpdates( data.photos );

		this.effect = "hslidein";
	}

	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		if (val != this._currentArea)
			this._currentArea = val;
	}

	create()
	{
		super.create();

		this.tabs = new fx.components.TabsHorizontal();

        // poster / cadre normal : photos, layouts, background, stickers
        // affiche perso : photos, stickers
        // affiche person IA : 

        //if (this.data.createdFromLayout || (!this.data.creation.useMedias && this.data.hasFilteredPhoto) || (this.data.creation.useMedias && !this.data.hasFilteredPhoto))
        if (!this.data.creation.useMedias || !this.data.hasFilteredPhoto)
        {
            this.photoPanel = new desktop.poster.PosterPhotosPanel( this.data, {automaticPlacingDisabled : true, filtersDisabled : true} );
            this.tabs.addTab(fx.text("Photos"), this.assets.PhotoTab, this.photoPanel);
        }
        
        if (!this.data.createdFromLayout || (this.data.creation.useMedias && !this.data.hasFilteredPhoto))
        {
            this.layoutPanel = new desktop.poster.LayoutsPanel( this.data );
            this.tabs.addTab(fx.text("Modèles"), this.assets.LayoutTab, this.layoutPanel);
        }

        if (!this.data.createdFromLayout && !this.data.hasFilteredPhoto)
        {
            this.backgroundPanel = new desktop.common.panels.BackgroundsPanel(  this.data );
            this.tabs.addTab(fx.text("Fonds"), this.assets.BackgroundTab, this.backgroundPanel);
        }
        
        this.stickerPanel = new desktop.common.panels.StickersPanel( this.data, {shapes : !this.data.createdFromLayout && !this.data.creation.useMedias} );
        this.tabs.addTab(fx.text("Stickers"), this.assets.StickerTab, this.stickerPanel);
        

        if(fx.get("app") != "config" && fx.get("mode") == "creating" && this.layoutPanel)
			this.tabs.selectTab( this.layoutPanel );

		this.addChild(this.tabs,  {width:"100%", height: "100%"});
	}

	onReady()
    {
		super.onReady();
	}

});
